import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { RadioGroup } from '@/components/radio-group'
import { SelectOption } from '@/models/common'
import { Space } from '@/styles'

import FieldWrapper from './field-wrapper'

export interface RadioGroupProps {
  label?: string
  options?: Array<SelectOption>
  optionProps?: SpaceProps | WidthProps
  fieldProps?: (SpaceProps & WidthProps) | WidthProps
  vertical?: boolean
  name?: string
  onChange?: (value: unknown) => void
  hideErrorMessage?: boolean
  disabled?: boolean
  tooltip?: string
}

const RadioGroupField: FunctionComponent<RadioGroupProps> = ({
  label,
  fieldProps,
  options,
  vertical,
  name,
  onChange,
  optionProps,
  hideErrorMessage,
  disabled,
  tooltip,
}: RadioGroupProps) => {
  const [field, meta, helpers] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error
  const handleClick = (value: unknown): void => {
    onChange && onChange(value)
    helpers.setValue && helpers.setValue(value)
  }

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} hideErrorMessage={hideErrorMessage} tooltip={tooltip}>
      <RadioGroup
        vertical={vertical}
        hasError={hasError}
        options={options}
        onClick={handleClick}
        selectedValue={field.value}
        name={field.name}
        fieldProps={{ mt: Space.S4 }}
        optionProps={optionProps}
        disabled={disabled}
      />
    </FieldWrapper>
  )
}

RadioGroupField.displayName = 'RadioGroupField'

export default RadioGroupField
